// AuthShell — the card-on-canvas frame the signed-out screens sit in.
// Mirrors review/commerce-app/auth.jsx. No AppShell: there is no navigation to
// offer somebody who is not signed in.
//
// Ported from the 2026-08-26 design drop,
// handoff/commerce-app/src/pages/AuthPages.tsx. Every departure from that file
// is marked ADAPTED and explains itself; the rest is the handoff as delivered,
// so a reissued prototype can be re-ported instead of merged.
//
// ADAPTED: the handoff points at `/assets/mDecide-logo.svg` and asks the host
// app to substitute its own hosted paths. Brand lockups are images, not tokens,
// so the dark surface needs its own file — the same pair, and the same reasoning,
// as AppShell's Logo.
import type { ReactNode } from 'react';
import { LEGAL } from '../legal';

const LOGO = {
  light: '/assets/mDecide-White-Background-v3.svg',
  dark: '/assets/mDecide-Dark-Background-v3.svg',
};

export function AuthShell({ width = 400, children }: { width?: number; children: ReactNode }) {
  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-6 bg-muted/30 p-8">
      <div className="rounded-xl border bg-card p-8 shadow-sm" style={{ width }}>
        <img src={LOGO.light} alt="mDecide" className="mb-6 h-6 dark:hidden" />
        <img src={LOGO.dark} alt="mDecide" className="mb-6 hidden h-6 dark:block" />
        {children}
      </div>
      <div className="text-xs text-muted-foreground">
        © 2026 metricsIQ LLC. ·{' '}
        <a
          href={LEGAL.privacy}
          className="hover:text-foreground"
          target="_blank"
          rel="noreferrer"
        >
          Privacy
        </a>{' '}
        ·{' '}
        <a
          href={LEGAL.terms}
          className="hover:text-foreground"
          target="_blank"
          rel="noreferrer"
        >
          Terms
        </a>
      </div>
    </div>
  );
}
